export const Earth = () =>{

 
    return(
        <section className="earth container1 center">
            <h1>Huge Global Network of Fast VPN</h1>
            <h2>See LaslesVPN everywhere to make it easier for you when you move<br/> locations.</h2>

            <div id="earth" className="sketchfab-embed-wrapper"> <iframe width={900} height={500}  title="Earth like" frameBorder="0"  src="https://sketchfab.com/models/3cc8fb92638b4395b5746ecf3c58c6bd/embed"> </iframe> </div>
        </section>
        
    )
}

